import $ from 'jquery';
import { getAuth0Client } from '~auth';

export const loginRoute = async () => {
  document.title = 'Login | Giotto';

  $('.editor-route').hide();
  $('#route-login').show();

  const auth0 = await getAuth0Client();

  await auth0.loginWithRedirect({
    redirect_uri: `${window.location.origin}/auth`,
  });
};
